import { render, staticRenderFns } from "./BatchProcessing.vue?vue&type=template&id=2ab6a38a&scoped=true&"
import script from "./BatchProcessing.vue?vue&type=script&lang=js&"
export * from "./BatchProcessing.vue?vue&type=script&lang=js&"
import style0 from "./BatchProcessing.vue?vue&type=style&index=0&id=2ab6a38a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab6a38a",
  null
  
)

export default component.exports